import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FormsActions from './forms.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class FormsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }

  initStore(type: number) {
    this.store.dispatch(new FormsActions.FormsRefresh(type));
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.FORMS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new FormsActions.FormsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new FormsActions.FormsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new FormsActions.FormsDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new FormsActions.FormsRefresh(data.type));
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new FormsActions.FormsRefreshByID(data.id));
          break;
      }
    });
  }
}
